var map = {
	"./brazil.png": "s4rr",
	"./france.png": "PZ7g",
	"./italy.png": "x+ZS",
	"./spain.png": "u/9s",
	"./united-kingdom.png": "8JBm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JhN8";


//////////////////
// WEBPACK FOOTER
// ./static/icons ^\.\/.*\.png$
// module id = JhN8
// module chunks = 1